import { initializeBeaconChannel } from "../channels/beacon_channel";
document.addEventListener('DOMContentLoaded', () => {
  initializeBeaconChannel();
});
